export interface InsuranceProvider {
  uid: string;
  name: string;
  description: string;
  data: Record<string, unknown>;
}

export interface MedicalPlan {
  id: string;
  title: string;
  description: string;
  content: string;
  price: string;
  period: string;
  image: string;
}

export interface InsurancePlan {
  id: number;
  idCard?: IdCardType
  uid: string;
  providerId: number;
  status: number;
  name: string;
  category: string;
  type: string;
  productFamily: string;
  metalTier: string;
  averagePrice: number;
  shortDescription: string;
  marketingName: string;
  networkName: string | null;
  marketSegment: string;
  priority: number;
  effectiveDate: string | null;
  terminationDate: string | null;
  eligGroup: string | string[];
  eligWaitingPeriod: string;
  eligEmployeeType: string;
  eligEnrollmentWindow: string | null;
  eligAgeLimit: number | null;
  eligDependentAgeLimit: number | null;
  archivedAt?: string | null;
  forbiddenStates?: string[];
  prices: Array<{
    id?: number;
    tier: string | null;
    price: number;
    coverage: number;
    archivedAt?: string | null;
    data?: {
      coverageAmount: number;
      dependentCount: number;
      minAge: number;
      maxAge: number;
      rate: number;
    } | {
      mb: number;
      db: number;
      d: number;
      p: { min: number; max: number };
      s: { min: number; max: number } | null;
    };
  }>;
  documents: Array<{
    displayName: string;
    fileName: string;
    path: string;
    type?: string;
    category?: string;
  }>;
  tags: string[];
  longDescription?: string;
  details?: Record<string, unknown>;
}

export enum IdCardType {
  None = 0,
  ClaimForm = 1,
  CignaMedical = 2,
  GuardianVision = 3,
  EquitableDental = 4,
}